import React, { useEffect, useState } from "react";
import "./Landing.css";

import Summary from "./summary.jsx";
import { Container, Flex } from "../../components/layout/index.jsx";
import { Title } from "../../components/ui/index.jsx";
import { TbArrowDown, TbChevronLeft, TbChevronRight } from "react-icons/tb";

import Landing1 from "../../assets/images/landing/landing1.jpg";
import Landing2 from "../../assets/images/landing/landing2.webp";
import Landing3 from "../../assets/images/landing/landing3.jpg";
import Landing4 from "../../assets/images/landing/landing4.jpg";

const images = [Landing1, Landing2, Landing3, Landing4];
const texts = [
  "Bienvenue à l'Ecrin Sauvage",
  "Chalet d'alpage authentique, simple et chaleureux",
  "Stages bien-être & coaching",
  "Pour une douce échappée au coeur des éléments",
];

function Landing() {
  const [index, setIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [timer, setTimer] = useState(null); // Stocke l’ID du timer

  // Précharge les images au démarrage
  useEffect(() => {
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  // Fonction pour changer d’image avec transition
  const changeSlide = (newIndex) => {
    if (isTransitioning) return; // Empêche une transition en cours
    setIsTransitioning(true);
    setNextIndex(newIndex);

    setTimeout(() => {
      setIndex(newIndex);
      setNextIndex(null);
      setIsTransitioning(false);
    }, 800); // Durée de l’animation CSS
  };

  const handleNext = () => {
    changeSlide((index + 1) % images.length);
    resetTimer(); // Reset du timer
  };

  const handlePrev = () => {
    changeSlide((index - 1 + images.length) % images.length);
    resetTimer(); // Reset du timer
  };

  // Gestion du timer automatique toutes les 8s
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 4000);

    setTimer(interval);

    return () => clearInterval(interval); // Nettoie le timer au démontage
  }, [index]); // Redémarre le timer à chaque changement d’index

  // Reset du timer quand on clique sur un chevron
  const resetTimer = () => {
    if (timer) clearInterval(timer);
  };

  const scrollTo = () => {
    // Scroll vers le sommaire - 200px
    window.scrollTo({
      top: document.getElementById("summary").offsetTop - 100,
      behavior: "smooth",
    });
  };

  return (
    <Container className="Landing">
      <Container className="header">
        <div className="image-container">
          {/* Image actuelle */}
          <div
            className="image active"
            style={{ backgroundImage: `url(${images[index]})` }}
          />

          {/* Prochaine image qui va apparaître en fondu */}
          {nextIndex !== null && (
            <div
              className="image fade-in"
              style={{ backgroundImage: `url(${images[nextIndex]})` }}
            />
          )}
        </div>

        {/* Contenu par-dessus les images */}
        <Flex type="col-between" className="overlay">
          <Container className="empty" />
          <Flex type="between-center" className="content" gap={20}>
            <TbChevronLeft className="icon" onClick={handlePrev} />
            <Title
              level="h3"
              className={`fade-text ${
                nextIndex !== null ? "fade-out" : "fade-in"
              }`}
            >
              {texts[index]}
            </Title>
            <TbChevronRight className="icon" onClick={handleNext} />
          </Flex>
          <TbArrowDown className="icon" onClick={scrollTo} />
        </Flex>
      </Container>

      <Summary />
    </Container>
  );
}

export default Landing;
